import * as React from 'react';
export const invoiceSvg = React.forwardRef(function invoiceSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D8DEE4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#474E5A',
      d: 'M11 12.875c0-.518.42-.937.938-.937h3.124a.937.937 0 1 1 0 1.875h-3.124a.937.937 0 0 1-.938-.938Zm.938 2.813a.937.937 0 1 0 0 1.875h8.124a.937.937 0 1 0 0-1.875h-8.125Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#474E5A',
      fillRule: 'evenodd',
      d: 'M7.941 26.096a1.25 1.25 0 0 1-.691-1.118V10.125C7.25 8.399 8.65 7 10.375 7h11.25c1.726 0 3.125 1.4 3.125 3.125V22c0 .393-.185.764-.5 1l-1.625 1.219a.625.625 0 0 1-.75 0l-1.73-1.297a.625.625 0 0 0-.775.02l-3.029 2.524a.625.625 0 0 1-.722.056l-2.326-1.396a.625.625 0 0 0-.763.094l-2.461 2.462a.625.625 0 0 1-.722.117l-1.406-.703Zm1.184-1.505V10.125c0-.69.56-1.25 1.25-1.25h11.25c.69 0 1.25.56 1.25 1.25v11.563l-.625.468-.98-.734a2.5 2.5 0 0 0-3.1.079l-2.347 1.956-1.565-.939a2.5 2.5 0 0 0-3.054.376L9.38 24.72l-.255-.128Z',
      clipRule: 'evenodd',
    }),
  );
});
invoiceSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var invoice = {
  category: 'brand',
  colorable: false,
  name: 'invoice',
  svg: invoiceSvg,
};
